"use strict";

const statusCodesRaw = {
  SIGN_IN_CANCELLED: 'SIGN_IN_CANCELLED',
  IN_PROGRESS: 'IN_PROGRESS',
  PLAY_SERVICES_NOT_AVAILABLE: 'PLAY_SERVICES_NOT_AVAILABLE',
  SIGN_IN_REQUIRED: 'SIGN_IN_REQUIRED'
};
export const statusCodes = Object.freeze(statusCodesRaw);
//# sourceMappingURL=errorCodes.web.js.map